import { Link } from 'react-router-dom';
import { FileQuestion } from 'lucide-react';
import AppIcon from '../components/AppIcon';
import { PageSeo } from '../components/Seo';

export default function NotFound() {
  return (
    <div className="container empty-state not-found-page">
      <PageSeo title="Sayfa Bulunamadı" noindex />
      <div className="empty-cart">
        <p className="not-found-code" aria-hidden>
          404
        </p>
        <span className="empty-icon">
          <AppIcon icon={FileQuestion} size={64} strokeWidth={1.5} />
        </span>
        <h2>Sayfa Bulunamadı</h2>
        <p>Aradığınız sayfa taşınmış, silinmiş veya hiç var olmamış olabilir.</p>
        <div className="hero-actions">
          <Link to="/" className="btn btn-primary">
            Ana Sayfa
          </Link>
          <Link to="/shop" className="btn btn-outline">
            Ürünleri Gör
          </Link>
        </div>
      </div>
    </div>
  );
}
